"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var request_1 = require("./request");
var cardioMachineLogSummary = require("./log-summary-service/cardio-machine-log-summary/cardio-machine-log-summary");
var coachVideoLogSummary = require("./log-summary-service/coach-video-summary/coach-video-summary");
var foodLogSummary = require("./log-summary-service/food-log-summary/food-log-summary");
var listWorkoutSummary = require("./log-summary-service/list-workout-summary/list-workout-summary");
var logType = require("./log-summary-service/log-type/log-type");
var manualLogSummary = require("./log-summary-service/manual-log-summary/manual-log-summary");
var wearableLogSummary = require("./log-summary-service/wearable-log-summary/wearable-log-summary");
var weightLogSummary = require("./log-summary-service/weight-log-summary/weight-log-summary");
var workoutEstimator = require("./workout-estimator/workout-estimator");
var GatewayApiClient = (function () {
    function GatewayApiClient(baseURL, privateToken, clientId, clientSecret, req) {
        if (req === void 0) { req = null; }
        this.baseURL = baseURL;
        this.privateToken = privateToken;
        this.clientId = clientId;
        this.clientSecret = clientSecret;
        this.req = req || new request_1.default();
        var baseOpts = {
            baseURL: baseURL
        };
        this.noAuthOpts = __assign({}, baseOpts);
        this.bearerOpts = __assign({}, baseOpts, {
            headers: {}
        });
        this.basicOpts = __assign({}, baseOpts, {
            auth: {
                password: clientSecret,
                username: clientId
            }
        });
        if (privateToken) {
            this.token = privateToken;
        }
        this.LogType = logType.createClass(this);
        this.CardioMachineLogSummary = cardioMachineLogSummary.createClass(this);
        this.ListWorkoutSummary = listWorkoutSummary.createClass(this);
        this.CardioMachineLogSummary = cardioMachineLogSummary.createClass(this);
        this.CardioMachineLogSummary = cardioMachineLogSummary.createClass(this);
        this.FoodLogSummary = foodLogSummary.createClass(this);
        this.WorkoutEstimator = workoutEstimator.createClass(this);
        this.WeightLogSummary = weightLogSummary.createClass(this);
        this.WearableLogSummary = wearableLogSummary.createClass(this);
        this.ManualLogSummary = manualLogSummary.createClass(this);
        this.CoachVideoLogSummary = coachVideoLogSummary.createClass(this);
    }
    Object.defineProperty(GatewayApiClient.prototype, "token", {
        get: function () {
            return "Bearer " + this.privateToken;
        },
        set: function (value) {
            this.privateToken = value.replace("Bearer ", "");
            this.bearerOpts.headers.Authorization = this.token;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GatewayApiClient.prototype, "hasBearer", {
        get: function () {
            return !!this.privateToken;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GatewayApiClient.prototype, "fallbackOpts", {
        get: function () {
            return this.hasBearer ? this.bearerOpts : this.basicOpts;
        },
        enumerable: true,
        configurable: true
    });
    return GatewayApiClient;
}());
exports.GatewayApiClient = GatewayApiClient;
//# sourceMappingURL=client.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ifit/gateway/out/api/client.js
// module id = 370
// module chunks = 0